export default function() {
    return {
        async getWorkDetails(id) {
            try {
                const response = await this.getAll();
                var workDetails = response.find(work => work.id == id);
                return [null, workDetails];
            } catch (error) {
                return [error];
            }
        },
        async getAll() {
            return [
                {
                    id: 0,
                    title: "Reimaging Onboarding Experience", 
                    tags: ["UI&UX", "Lottie"],
                    description: "To ensure that every new and existing customer, regardless of their race, enjoys a seamless and user-friendly onboarding process.",
                    cardCoverImg: "mynjoi-onboarding-cover.png",
                    pageCoverImg: "reimaging-onboarding.png",
                    year: "2023",
                    duration: "Mar-Jun 2023",
                    method: "Double Diamond",
                    roles: ["UX Research", "UX & UI Design", "Animation Design"],
                    platforms:["App"],
                    team: ["Kathy - Project Manager", "Stacey - iOS Developer" , "Zen - Android Developer"],
                    tools: ["Figma", "Adobe After Effect", "Lottie", "Google Analytics"],
                    targetAudience: "Prospect and Customer",
                    processComponent: "reimaging-onboarding-process",
                },
                {
                    id: 1,
                    title: "Increase Platform Leads", 
                    tags:['UI&UX', 'Lottie'],
                    description: "Enhance the disjointed experience of new customers and boost lead generation.",
                    cardCoverImg: 'njoi-productsignup-cover.png',
                    pageCoverImg: "increase-lead.png",
                    year: '2023',
                    duration: "Feb-Mar 2023",
                    method: "Double Diamond",
                    roles: ["UX Research", "UX & UI Design", "Animation Design"],
                    platforms:["Web"],
                    team: ["Kajal - Front-end Developer", "Kathy - Project Manager"],
                    tools: ["Figma", "Adobe After Effect", "Lottie", "Google Analytics", "Hotjar"],
                    targetAudience: "Prospect",
                    processComponent: "increase-platform-lead",
                },
                {
                    id: 2,
                    title: "Seamless Sign Up", 
                    tags:['UI&UX', 'Branding'],
                    description: "Simplify the complicated journey of signing up and activating to drive higher engagement.",
                    cardCoverImg: 'einvest-ekyc-cover.png',
                    pageCoverImg: "einvest-sign-up.png",
                    year: '2021',
                    duration: "Apr-May 2021",
                    method: "Double Diamond",
                    roles: ["Branding Design", "UX & UI Design"],
                    platforms:["Web"],
                    team: ["Ikram - Front-end Lead", "Marcus - HOD" , "Kelvin - Back-end Developer", "Faiz - Copywriter", "Marketing Team - Ivan and Claire"],
                    tools: ["Figma"],
                    targetAudience: "Prospect and Existing Customer",
                    processComponent: "seamless-sign-up",
                },
                {
                    id: 3,
                    title: "Crafting Our Narrative", 
                    tags:['UI&UX'],
                    description: "Design embodies our identity.",
                    cardCoverImg: 'einvest-aboutus-cover.png',
                    pageCoverImg: "einvest-sign-up.png",
                    year: '2021',
                    duration: "Apr-May 2021",
                    method: "Double Diamond",
                    roles: ["Branding Design", "UX & UI Design"],
                    platforms:["Web"],
                    team: ["Ikram - Front-end Lead", "Marcus - HOD" , "Kelvin - Back-end Developer", "Faiz - Copywriter", "Marketing Team - Ivan and Claire"],
                    tools: ["Figma"],
                    targetAudience: "Prospect and Existing Customer",
                    // processComponent: "seamless-sign-up",
                },
                {
                    id: 4,
                    title: "Home Cooked App", 
                    tags: ["UI&UX", "Project Management"],
                    description: "Inspired home cook to start business at home.",
                    cardCoverImg: "homecooked-cover.png",
                    pageCoverImg: "reimaging-onboarding.png",
                    year: "2022",
                    duration: "Mar-Jun 2023",
                    method: "Double Diamond",
                    roles: ["UX Research", "UX & UI Design", "Animation Design"],
                    platforms:["App"],
                    team: "My NJOI Dev Team",
                    tools: ["Figma", "Adobe After Effect", "Lottie", "Google Analytics"],
                    targetAudience: "New Customers",
                },
                {
                    id: 5,
                    title: "Bubble Tea App", 
                    tags: ["UI&UX", "Project Management"],
                    description: "Inspired home cook to start business at home.",
                    cardCoverImg: "bubbletea-cover.png",
                    pageCoverImg: "reimaging-onboarding.png",
                    year: "2022",
                    duration: "Mar-Jun 2023",
                    method: "Double Diamond",
                    roles: ["UX Research", "UX & UI Design", "Animation Design"],
                    platforms:["App"],
                    team: "My NJOI Dev Team",
                    tools: ["Figma", "Adobe After Effect", "Lottie", "Google Analytics"],
                    targetAudience: "New Customers",
                },
                // {
                //     id: 5,
                //     title: "Facial Recognition Dashboard", 
                //     tags: ["UI&UX", "Front-end"],
                //     description: "Inspired home cook to start business at home.",
                //     cardCoverImg: "facial-recognition.png",
                //     pageCoverImg: "reimaging-onboarding.png",
                //     year: "2018",
                //     duration: "Mar-Jun 2023",
                //     method: "Double Diamond",
                //     roles: ["UX Research", "UX & UI Design", "Animation Design"],
                //     platforms:["Program"],
                //     team: "My NJOI Dev Team",
                //     tools: ["Figma", "Adobe After Effect", "Lottie", "Google Analytics"],
                //     targetAudience: "New Customers",
                // },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/repository/workRepository.js